import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getAuditorsURL } from '../utils/api';

const useGetAuditors = ({ 
        page = 1,
        limit = 3000,
        keyword,
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingAuditors, setGettingAuditors ] = useState(false);
    const [ auditors, setAuditors ] = useState([]);
    const [ totalAuditors, setTotalAuditors ] = useState(0);
    const [ gettingAuditorsReqSuccess, setGettingAuditorsReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingAuditors) {
            axios.get(getAuditorsURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    page,
                    limit,
                    keyword,
                }
            }).then(result => {
                setGettingAuditors(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalAuditors(result.data.total);
                    }
                    setGettingAuditorsReqSuccess(true);
                    setAuditors(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingAuditorsReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingAuditorsReqSuccess(false);
                setGettingAuditors(false);
            });
        }
    }, [gettingAuditors]);

    return { auditors, totalAuditors, gettingAuditors, setGettingAuditors, gettingAuditorsReqSuccess };
}

export default useGetAuditors;